import { Component, OnInit, ViewChild } from '@angular/core';
import { FirebaseService } from 'src/app/services/firebase.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {

  displayedColumns: string[] = ['email', 'phn','blank', 'message'];
  dataSource : MatTableDataSource<any[]>;

  
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;


  constructor(private firebase: FirebaseService, private afs:AngularFireStorage, private router: Router) {
    this.firebase.getMessages().subscribe( res => {
      this.dataSource=new MatTableDataSource<any>(res);
      this.dataSource.paginator = this.paginator;
    });
   }

  ngOnInit(): void {
  }

}
